module.exports = require("react-timeago");